



























import {
  saveProjectFolderDefault,
  SaveProjectFolderDefaultCommand,
  getProjectFolderDefault
} from "@/api/project/project-folder-default-api";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class ProjectFolderDefaultCreatePage extends Vue {
  id: string = "";

  @Watch("$route.params.id", { immediate: true })
  onIdChanged(id: string) {
    this.initKey(id);
  }
  command: SaveProjectFolderDefaultCommand = {
    name: "",
    type: ""
  };

  created() {
    this.id = this.$route.params.id;
  }

  async submit() {
    if (!this.$route.params.isType) return;

    this.command.type = this.$route.params.isType;
    await saveProjectFolderDefault(this.command);

    if (this.$route.params.isType === "image") {
      this.$router.replace("/admin/project/folder-default/image");
    } else {
      this.$router.replace("/admin/project/folder-default/draw");
    }
  }

  clickSubmitButton() {
    (this.$refs["btnSubmit"] as any).click();
  }

  async initKey(id: string) {
    if (!id) return;

    this.command = (await getProjectFolderDefault(
      id
    )) as SaveProjectFolderDefaultCommand;
  }
}
